import { render, staticRenderFns } from "./BrokenMode.vue?vue&type=template&id=16b9c643&"
import script from "./BrokenMode.vue?vue&type=script&lang=js&"
export * from "./BrokenMode.vue?vue&type=script&lang=js&"
import style0 from "./BrokenMode.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend-internal/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BButton, BContainer} from 'bootstrap-vue'
    installComponents(component, {BButton, BContainer})
    

export default component.exports